import React from 'react';
interface IconProps {
  width?: number;
  height?: number;
}

const HomeValueIconAndereWoning = (props: IconProps) => {
  return (
    <svg width={57} height={54} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M29.2 52.667V37.17h-9.686v15.497M50.508 39.108V23.611h-6.78v15.497"
        stroke="currentColor"
        strokeWidth={1.65}
        strokeLinejoin="round"
      />
      <path
        d="M10.797 21.674l13.56-7.748 13.56 7.748"
        stroke="currentColor"
        strokeWidth={1.65}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.111 17.8l8.233-5.812 8.233 5.812M55.35 9.082L43.245 1.334 31.137 9.082M10.797 24.58v28.088h27.12V24.58M1.111 20.705v21.308H8.86M55.35 11.988v27.12H37.918M31.137 17.8v-5.812"
        stroke="currentColor"
        strokeWidth={1.65}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HomeValueIconAndereWoning;
